import React, { forwardRef } from 'react';
import classNames from 'classnames';
/**
 * @experimental
 * - `className` is forwarded with classNames wrapper
 * - Props starting with `on` are extended
 * - customizable set of extendable props
 */
export const extendComponent = (Component, defaultProps, options = {}) => {
    return forwardRef((props, ref) => {
        let extendedProps = { ...props };
        if (extendedProps.className)
            extendedProps.className = classNames([defaultProps.className, extendedProps.className]);
        extendedProps = { ...defaultProps, ...extendedProps };
        for (const [key, value] of Object.entries(defaultProps)) {
            if (key.startsWith('on') && props[key])
                extendedProps[key] = (...args) => {
                    defaultProps[key](...args);
                    props[key](...args);
                };
        }
        //@ts-ignore
        return React.createElement(Component, { ref: ref, ...extendedProps });
    });
};
